








export default {
  name: 'text-content',

  props: ['content']
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TextContent.vue